import React, { useState } from 'react'
import {
    BrowserRouter as Router,
    Route,
    Link
  } from 'react-router-dom';

import { useEffect } from 'react';
import Top from '../../Components/Top';
import Navbar from '../../Components/Navbar';
import './Compe.css'
import Footer from '../../Components/Footer';

function CompeInside({map}) {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
      }, []);    
  return (
    <div className=''>
        <Navbar />
        <Top />

        {/* Desktop View */}
        <Link to="/competition" className='text-white lg:block hidden text-3xl ml-[30px] rounded-md hover:bg-gray-300/30 w-[60px] text-center p-[10px] mb-[30px] mt-[30px]'>{'<'}</Link>
        <div className='hidden lg:flex flex-row mb-[100px] overflow-hidden'>
            <img src={require(`../../Assets/poster/${map.coverImg}`)} alt="" className='w-1/4 ml-[30px] mt-[30px] shadow-2xl shadow-purple-500' />
            <div className='ml-[50px] my-auto'>
                <h2 className='text-left mb-[10px] text-white font-[JakartaSansBold] text-9xl mt-[30px]'>{map.name}</h2>
                <p className='text-left mb-[10px] text-white text-3xl'>{map.description}</p>
                <div className='lg:grid md:grid grid-cols-2 w-full px-[10px] mb-[2rem]'>
            <div className='lg:mx-auto md:mx-auto mr-[10px] gap-2 mt-[30px] bg-gray-300/50 text-white rounded-lg border-white border-[1.5px] mx-[10px]'>
                <table className='table-fixed mx-auto'>
                    <thead className=''>
                        <tr className='my-[20px] border-b-[2px]'>
                            <th className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px]  font-semibold text-[20px] border-r-[1.5px] border-white'>Event</th>
                            <th className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px]  font-semibold text-[20px]'>Date</th>
                        </tr>
                    </thead>
                    <tbody className=''>
                        <tr>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Registrasi Ditutup</td>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center  tracking-wide'>22 Oktober 2023</td>
                        </tr>
                        <tr>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Technical Meeting</td>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide'>{map.tm}</td>
                        </tr>
                        <tr>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Competition</td>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide'>{map.start}</td>
                        </tr>
                        <tr>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Closing+Prize Announcement</td>
                            <td className='lg:px-[10px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide'>03 November 2023</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className=' mx-[10px] md:mx-auto lg:mx-auto mt-[30px] bg-gray-300/50 text-white rounded-lg border-white border-[1.5px] px-[30px] my-auto py-[20px] pb-[30px]'>
                <h1 className='font-semibold text-[20px] lg:text-[25px]'>Penanggung Jawab</h1>
                <p className='text-left'>{map.coord1}</p>
                {map.line1 ? ( <p className='flex'><img src={require("../../Assets/line.webp")} alt="" className='h-[30px] mr-[10px]' />{map.line1}</p> ) : ''}
                {/* <p className='text-left'>{map.coord2}</p> */}
                    <div>
                        {map.coord2 ? ( <p className='text-left'>{map.coord2}</p> ) : ''}
                        {map.line2 ? (<p className={`flex`}><img src={require("../../Assets/line.webp")} alt="" className='h-[30px] mr-[10px]' />{map.line2}</p>   ) : ''}  
                    </div>
            </div>
        </div>
            </div>
        </div>

        {/* Mobile View */}
        <div className='block lg:hidden'>
            <img src={require(`../../Assets/poster/${map.coverImg}`)} alt="" className='w-1/4 mx-auto mt-[30px] shadow-2xl shadow-purple-500' />
            <h2 className='text-center text-white font-[JakartaSansBold] text-4xl mt-[30px]'>{map.name}</h2>
            <p className='text-center mx-[50px] text-white'>{map.description}</p>
        </div>
        {/* <div className={`overflow-hidden text-white font-[800] ${map.class} h-[600px] hidden md:block lg:block`}>
            <div className='px-[20px] w-full bg-gradient-to-r from-[#0E021C]/100 via-[#0E021C]/95 to-[#0E021C]/0 h-full pt-[20px]'>
                <Link to='/competition' className='text-[25px] text-left w-full font-[300] mb-[30px]'>{'<'}</Link>
                <h1 className='lg:text-[150px] text-[100px] text-left blur-none '>{map.name}</h1>
                <p className=' text-[20px] font-[200] text-justify lg:w-[800px] md:w-[500px]'>
                {map.description}
                </p>
            </div>
        </div>
        <div className={`overflow-hidden text-white font-[800] ${map.smallclass} h-[450px] block md:hidden lg:hidden`}>
            <div className='px-[0px] w-full bg-gradient-to-t from-[#0E021C]/100 via-[#0E021C]/90 to-[#0E021C]/0 h-full pt-[20px] relative bottom-0'>
                <div className="bottom-0 absolute mb-[30px] mx-[10px]">
                    <h1 className='lg:text-[150px] text-[40px] text-center blur-none '>{map.name}</h1>
                    <p className=' text-[15px] font-[200] text-center lg:w-[800px]'>
                        {map.description}
                    </p>
                </div>
            </div>
        </div> */}
        <div className='lg:hidden md:grid grid-cols-2 w-full px-[10px] mb-[2rem]'>
            <div className='lg:mx-auto md:mx-auto mt-[30px] bg-gray-300/50 text-white rounded-lg border-white border-[1.5px] mx-[10px]'>
                <table className='table-fixed mx-auto'>
                    <thead className=''>
                        <tr className='my-[20px] border-b-[2px]'>
                            <th className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px]  font-semibold text-[20px] border-r-[1.5px] border-white'>Event</th>
                            <th className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px]  font-semibold text-[20px]'>Date</th>
                        </tr>
                    </thead>
                    <tbody className=''>
                        <tr>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Registrasi Ditutup</td>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center  tracking-wide'>22 Oktober 2023</td>
                        </tr>
                        <tr>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Technical Meeting</td>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide'>{map.tm}</td>
                        </tr>
                        <tr>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Competition</td>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide'>{map.start}</td>
                        </tr>
                        <tr>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide border-r-[1.5px] border-white'>Closing+Prize Announcement</td>
                            <td className='lg:px-[50px] lg:py-[10px] px-[10px] py-[5px] text-center tracking-wide'>03 November 2023</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className=' mx-[10px] md:mx-auto lg:mx-auto mt-[30px] bg-gray-300/50 text-white rounded-lg border-white border-[1.5px] px-[30px] my-auto py-[20px] pb-[30px]'>
                <h1 className='font-semibold text-[20px] lg:text-[35px]'>Penanggung Jawab</h1>
                <p className='text-left'>{map.coord1}</p>
                {map.line1 ? ( <p className='flex'><img src={require("../../Assets/line.webp")} alt="" className='h-[30px] mr-[10px]' />{map.line1}</p> ) : ''}
                {/* <p className='text-left'>{map.coord2}</p> */}
                    <div>
                        {map.coord2 ? ( <p className='text-left'>{map.coord2}</p>) : ''}
                        {map.line2 ? ( <p className={`flex`}><img src={require("../../Assets/line.webp")} alt="" className='h-[30px] mr-[10px]' />{map.line2}</p> ) : ''} 
                    </div>
            </div>
        </div>
        <Footer />
    </div>
  )
}

export default CompeInside